import { CasEntitySelect, componentProps } from 'src/compass/shared/components';

export function SalesCodeSelect(props: componentProps) {
  return CasEntitySelect('Cme/SalesCode/Select', props);
}
